'use client';

import { useEffect } from 'react';
import { useTrackedTimeouts } from './use-tracked-timeouts';

/**
 * Scans the document for `.reveal, .reveal-left, .reveal-right, .reveal-scale`
 * elements and adds the `.visible` class as each scrolls into view. Respects
 * per-element `data-delay` in ms.
 *
 * Shell-level hook because `.reveal*` classes appear in every landing-page
 * section. Extracted from `app/page.js` lines 180-193.
 *
 *   export default function LandingPage() {
 *     useRevealObserver();
 *     // ...
 *   }
 */
export function useRevealObserver() {
  const { setT } = useTrackedTimeouts();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.delay || '0', 10);
            setT(() => entry.target.classList.add('visible'), delay);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' },
    );

    document
      .querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale')
      .forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
    };
  }, [setT]);
}
